import {ReactourStep} from "reactour";
import * as React from "react";
import {Dispatch, useContext} from "react";
import Text1 from "../Text1";
import {useTour} from "@reactour/tour";
import Tooltip from "../Tooltip";
import {Button, IconButton} from "@material-ui/core";
import {ChevronLeft, ChevronRight, Duo, KeyboardArrowRight} from "@material-ui/icons";
import {AppDispatchContext, AppStateContext} from "../../../App";
import {iStoreAction} from "../../../redux/reducers";
import "./styles.scss"
import {useHistory, useLocation} from "react-router-dom";
import campaign_1 from "../../../assets/images/campaigns/create-campaigns-1.png"
import campaign_2 from "../../../assets/images/campaigns/create-campaigns-2.png"
import campaign_3 from "../../../assets/images/campaigns/create-campaigns-3.png"
import campaign_4 from "../../../assets/images/campaigns/create-campaigns-4.png"
import campaign_5 from "../../../assets/images/campaigns/create-campaigns-5.png"
import campaign_6 from "../../../assets/images/campaigns/create-campaigns-6.png"
import campaign_7 from "../../../assets/images/campaigns/create-campaigns-7.png"
import automation_1 from "../../../assets/images/automations/create-automation-1.png"
import {ContentProps, StepType, TourProps} from "@reactour/tour/dist/types";
import CloseIcon from "@material-ui/icons/Close";
import i18n from "../../../i18n";

const tt = (key: string, options?: Record<string, unknown>) =>
    i18n.t(key, { ns: "tour", ...(options || {}) });

export const TOUR_HOME = "TOUR_HOME";
export const TOUR_EMAIL_CAMPAIGN = "TOUR_EMAIL_CAMPAIGN";
export const TOUR_EMAIL_AUTOMATION = "TOUR_EMAIL_AUTOMATION";
export const TOUR_EMAIL = "TOUR_EMAIL";
export const TOUR_CHATS = "TOUR_CHATS";
export const TOUR_REVIEWS = "TOUR_REVIEWS";
export const TOUR_REVIEWS_SETTINGS = "TOUR_REVIEWS_SETTINGS";
export const TOUR_CHATS_SETTINGS = "TOUR_CHATS_SETTINGS";
export const TOUR_SKIP = "TOUR_SKIP";

// export function getTourSteps(tour_type: string) {
//
//     if (tour_type === TOUR_HOME) {
//         return _HomeConfig
//     }
//     if (tour_type === TOUR_EMAIL) {
//         return _emailConfig
//     }
//     if (tour_type === TOUR_EMAIL_CAMPAIGN) {
//         return _emailCampaignConfig
//     }
//     if (tour_type === TOUR_EMAIL_AUTOMATION) {
//         return _emailAutomationConfig
//     }
//     if (tour_type === TOUR_CHATS) {
//         return _chatConfig
//     }
//     if (tour_type === TOUR_SKIP) {
//         return _skipTourConfig
//     }
//
//     return []
// }
export function TourControls({
                                 props,
                                 onBack,
                                 onNext
                             }: { props: ContentProps, onBack?: () => void, onNext?: () => void }) {
    return <div className="w-100 d-flex justify-content-around mt-2">
        <IconButton onClick={onBack ? onBack : () => {
            if (props.currentStep > 0) {
                props.setCurrentStep(props.currentStep - 1)
            }
        }}>
            <ChevronLeft/>
        </IconButton>
        <IconButton onClick={onNext ? onNext : () => {
            props.setCurrentStep(props.currentStep + 1)
        }}>
            <ChevronRight/>
        </IconButton>
    </div>
}

export function TourWrapper({
                                children
                            }: { children: any }) {
    const {setIsOpen} = useTour();
    return <div>
        <div className="d-flex justify-content-end">
            <IconButton onClick={() => {
                setIsOpen(false)
            }}>
                <CloseIcon/>
            </IconButton>
        </div>
        <div>
            {children}
        </div>

    </div>
}

export function TourContent({
                                children
                            }: { children: any }) {

    return <div>
        {children}
    </div>
}

export function _HomeConfig(history: any, tour_props: TourProps, dispatch?: any): StepType[] {

    return [
        {
            selector: '[data-tut="reactour__header_dashboard"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => {

                return <TourWrapper>
                    <TourContent>
                        {tt("home.dashboardLine1")} <br/>
                        {tt("home.dashboardLine2")}
                        <br/>
                        <a href="https://www.youtube.com/channel/UCsZsVmPUNnvJblHDURUbWMQ/videos" target="_blank" rel="noopener noreferrer">
                            {tt("home.learnVideos")}
                        </a>
                    </TourContent>

                    <TourControls props={props}/>
                </TourWrapper>
            }
        },
        {
            selector: '[data-tut="reactour__header_email"]',

            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("emailNav.body")}
                        <br/>
                        <br/>
                        <div>
                        <span className="mb-4">
                            {tt("checkFollowing")}
                        </span>
                            <ul className="tour-choose-list">
                                {
                                    [
                                        {
                                            value: tt("emailNav.optSummary"),
                                            onClick: () => {
                                                history.push("/email")
                                                props.setCurrentStep(5)
                                            },
                                        },
                                        {
                                            value: tt("emailNav.optCampaigns"),
                                            onClick: () => {
                                                history.push("/email/campaigns")


                                                props.setCurrentStep(11)


                                            },
                                        },
                                        {
                                            value: tt("emailNav.optFlows"),
                                            onClick: () => {

                                                history.push("/email/automations")
                                                props.setCurrentStep(19)


                                            },
                                        },
                                    ].map((value, index) => {
                                        return <li key={index} onClick={value.onClick}>
                                        <span>
                                            {value.value}
                                        </span>
                                            <KeyboardArrowRight/>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </TourContent>
                    <TourControls props={props}/>

                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__header_chats"]',
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chatsNav.body")}
                        <br/>
                        <br/>
                        <div>
                        <span className="mb-4">
                            {tt("checkFollowing")}
                        </span>
                            <ul className="tour-choose-list">
                                {
                                    [
                                        {
                                            value: tt("chatsNav.optEnable"),
                                            onClick: () => {
                                                history.push("/chats")
                                                props.setCurrentStep(22)
                                            },
                                        },
                                        {
                                            value: tt("chatsNav.optSettings"),
                                            onClick: () => {
                                                history.push("/chats/settings")
                                                props.setCurrentStep(23)
                                            },
                                        },

                                    ].map((value, index) => {
                                        return <li key={index} onClick={value.onClick}>
                                        <span>
                                            {value.value}
                                        </span>
                                            <KeyboardArrowRight/>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </TourContent>
                    <TourControls props={props}/>

                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__header_reviews"]',
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("reviewsNav.body")}
                        <br/>
                        <br/>
                        <div>
                        <span className="mb-4">
                            {tt("checkFollowing")}
                        </span>
                            <ul className="tour-choose-list">
                                {
                                    [
                                        {
                                            value: tt("reviewsNav.optEnable"),
                                            onClick: () => {
                                                history.push("/reviews")
                                                props.setCurrentStep(41)
                                            },
                                        },
                                        {
                                            value: tt("reviewsNav.optSettings"),
                                            onClick: () => {
                                                history.push("/reviews/settings")
                                                props.setCurrentStep(42)

                                            },
                                        },

                                    ].map((value, index) => {
                                        return <li key={index} onClick={value.onClick}>
                                        <span>
                                            {value.value}
                                        </span>
                                            <KeyboardArrowRight/>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__header_popups"]',
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("popupsNav.body")}
                        <br/>
                        <br/>
                        <div>
                        <span className="mb-4">
                            {tt("checkFollowing")}
                        </span>
                            <ul className="tour-choose-list">
                                {
                                    [
                                        {
                                            value: tt("popupsNav.optEnable"),
                                            onClick: () => {
                                                history.push("/popups")
                                                props.setCurrentStep(53)
                                            },
                                        },
                                        {
                                            value: tt("popupsNav.optBuilder"),
                                            onClick: () => {
                                                dispatch && dispatch({
                                                    type: "popup_tour_shown",
                                                    popup_tour_shown: false
                                                })
                                                history.push("/popups")
                                                props.setCurrentStep(54)

                                            },
                                        },


                                    ].map((value, index) => {
                                        return <li key={index} onClick={value.onClick}>
                                        <span>
                                            {value.value}
                                        </span>
                                            <KeyboardArrowRight/>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </TourContent>
                    <TourControls props={props} onNext={() => {
                    }}/>
                </TourWrapper>
            ),
        },

        //email 5 done
        {
            selector: '[data-tut="reactour__sidebar_email_summary"]',
            mutationObservables: ['.app-loader'],

            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("emailSummary")}
                    </TourContent>
                    <TourControls props={props} onBack={() => {
                        history.push("/dashboard")
                        props.setCurrentStep(1)
                    }}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__sidebar_email_campaigns"]',
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("emailCampaigns.body")}
                        <br/>
                        <div>
                        <span className="mb-4">
                            {tt("checkFollowing")}
                        </span>
                            <ul className="tour-choose-list">
                                {
                                    [
                                        {
                                            value: tt("emailCampaigns.howCreate"),
                                            onClick: () => {
                                                history.push("/email/campaigns")

                                            },
                                        },
                                    ].map((value, index) => {
                                        return <li key={index} onClick={value.onClick}>
                                        <span>
                                            {value.value}
                                        </span>
                                            <KeyboardArrowRight/>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__sidebar_email_automations"]',
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("emailAutomations.body")}
                        <br/>
                        <div>
                        <span className="mb-4">
                            {tt("checkFollowing")}
                        </span>
                            <ul className="tour-choose-list">
                                {
                                    [
                                        {
                                            value: tt("emailAutomations.howCreate"),
                                            onClick: () => {
                                                history.push("/email/automations")

                                            },
                                        },
                                    ].map((value, index) => {
                                        return <li key={index} onClick={value.onClick}>
                                        <span>
                                            {value.value}
                                        </span>
                                            <KeyboardArrowRight/>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__sidebar_email_lists"]',
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("emailLists")}
                    </TourContent>
                    <TourControls props={props}  />
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__sidebar_email_templates"]',
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("emailTemplates")}
                    </TourContent>
                    <TourControls props={props} />
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__sidebar_email_segments"]',
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("emailSegments")}
                    </TourContent>
                    <TourControls props={props} onNext={()=>{
                        history.push("/email/campaigns")
                        setTimeout(()=>{
                            props.setCurrentStep(11)
                        },2000)

                    }}/>
                </TourWrapper>
            )
        },

        //email campaign 11 done
        {
            selector: '[data-tut="reactour__create_campaigns"]',
            mutationObservables: ['.app-loader'],

            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("campaign.clickAdd")}
                    </TourContent>
                    <TourControls props={props} onBack={() => {
                        props.setCurrentStep(1)
                    }}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__create_campaigns"]',
            position: "left",
            content: (props: ContentProps) => (
                <TourWrapper>
                    <img src={campaign_1} alt={tt("campaign.imageAlt")} />
                    <TourControls props={props}/>
                </TourWrapper>
            ),

        },
        {
            selector: '[data-tut="reactour__create_campaigns"]',
            position: "left",
            content: (props: ContentProps) => (
                <TourWrapper>
                    <img src={campaign_2} alt={tt("campaign.imageAlt")}/>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__create_campaigns"]',

            content: (props: ContentProps) => (
                <TourWrapper>
                    <img src={campaign_3} alt={tt("campaign.imageAlt")}/>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__create_campaigns"]',

            content: (props: ContentProps) => (
                <TourWrapper>
                    <img src={campaign_4} alt={tt("campaign.imageAlt")}/>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__create_campaigns"]',

            content: (props: ContentProps) => (
                <TourWrapper>
                    <img src={campaign_5} alt={tt("campaign.imageAlt")}/>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__create_campaigns"]',
            position: "top",
            content: (props: ContentProps) => (
                <TourWrapper>
                    <img src={campaign_6} alt={tt("campaign.imageAlt")}/>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {

            selector: '[data-tut="reactour__create_campaigns"]',

            content: (props: ContentProps) => (
                <TourWrapper>
                    <img src={campaign_7} alt={tt("campaign.imageAlt")}/>
                    <TourControls props={props} onNext={() => {
                        props.setCurrentStep(1)
                    }}/>
                </TourWrapper>
            )
        },

        //email automation 19 done
        {
            selector: '[data-tut="reactour__create_automations"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("automation.clickAdd")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__create_automations"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <div>
                        <p>
                            {tt("automation.createTitle")}
                        </p>
                    </div>
                    <div className="tour-image-view">

                        <img src={automation_1} alt={tt("automation.imageAlt")}/>
                    </div>
                    <TourControls props={props} onNext={() => {
                        props.setCurrentStep(1)
                    }}/>
                </TourWrapper>
            )
        },

        //chat 22
        {
            selector: '[data-tut="reactour__chat_enable"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.enableSwitch")}
                    </TourContent>
                    <TourControls props={props} onBack={() => {
                        props.setCurrentStep(2)
                    }}/>
                </TourWrapper>
            )
        },

        //chat settings 23
        {
            selector: '[data-tut="reactour__sidebar_chat_settings"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.editDesign")}
                    </TourContent>
                    <TourControls props={props} onNext={() => {
                        history.push("/chats/settings");
                        props.setCurrentStep(props.currentStep + 1);
                    }}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_photo"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.uploadPhoto")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_info_message"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.infoMessage")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_bot_name"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.agentName")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_offline_message"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.offlineMessage")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_welcome_message"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.welcomeMessage")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_primary_background_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.primaryBg")}
                    </TourContent>

                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_primary_text_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.primaryText")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_secondary_background_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.secondaryBg")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_secondary_text_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.secondaryText")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_guest_message_background_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.guestMsgBg")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_guest_message_text_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.guestMsgText")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_admin_message_background_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.adminMsgBg")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_admin_message_text_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.adminMsgText")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_input_background_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.inputBg")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_input_text_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.inputText")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_font_family"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.fontFamily")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_file_sharing_enabled"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.fileSharing")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__chat_settings_save_button"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("chat.saveSettings")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },

        //review 41
        {
            selector: '[data-tut="reactour__review_enable"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.enableSwitch")}
                    </TourContent>
                    <TourControls props={props} onBack={() => {
                        props.setCurrentStep(3)
                    }} onNext={() => {
                        props.setCurrentStep(3)
                    }}/>
                </TourWrapper>
            )
        },
        //review settings 42
        {
            selector: '[data-tut="reactour__sidebar_review_settings"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.editDesign")}
                    </TourContent>

                    <TourControls props={props} onBack={() => {
                        props.setCurrentStep(3)
                    }}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__review_font_family"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.primaryFont")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },

        {
            selector: '[data-tut="reactour__review_secondary_font_family"]',
            mutationObservables: ['.app-loader'],
            position: "left",
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.secondaryFont")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__review_primary_background_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.primaryBg")}
                    </TourContent>

                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__review_primary_text_color"]',
            mutationObservables: ['.app-loader'],
            position: "left",
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.primaryText")}
                    </TourContent>

                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__review_secondary_background_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.secondaryBg")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__review_secondary_text_color"]',
            mutationObservables: ['.app-loader'],
            position: "left",
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.secondaryText")}
                        <br />
                        {tt("review.secondaryLabel")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },

        {
            selector: '[data-tut="reactour__review_active_star_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.activeStar")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },

        {
            selector: '[data-tut="reactour__review_inactive_star_color"]',
            mutationObservables: ['.app-loader'],
            position: "left",
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.inactiveStar")}
                    </TourContent>

                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__review_separator_color"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.separator")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },

        {
            selector: '[data-tut="reactour__review_submit_button"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("review.saveSettings")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },
        {
            selector: '[data-tut="reactour__popup_enable_button"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("popup.enableSwitch")}
                    </TourContent>

                    <TourControls props={props}/>
                </TourWrapper>
            )
        },

        {
            selector: '[data-tut="reactour__popup_add_button"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <TourContent>
                        {tt("popup.clickAdd")}
                    </TourContent>
                    <TourControls props={props}/>
                </TourWrapper>
            )
        },

        //skip
        {
            selector: '[data-tut="reactour__skip_tour"]',
            mutationObservables: ['.app-loader'],
            content: (props: ContentProps) => (
                <TourWrapper>
                    <div className="mb-3"/>
                    <span className={"mb-1"}>
                                   {tt("skip.replay")}
                    </span>

                    <br/>
                    <br/>
                    <div className="d-flex justify-content-center">
                        <Duo/>
                    </div>
                    <br/>
                    <div className="d-flex justify-content-center">
                        <div>
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                className="positive-button"
                                onClick={() => {
                                    props.setCurrentStep(props.currentStep + 1)
                                }}
                            >
                                {tt("skip.gotIt")}
                            </Button>
                        </div>
                    </div>

                </TourWrapper>
            ),
        },


    ]
}

export function HomeTour() {
    // const {tour} = useContext(AppStateContext);
    // const history = useHistory();
    // const location = useLocation();
    // const tour_props = useTour();
    // const {setSteps, setCurrentStep,} = tour_props;

    //const dispatch: Dispatch<iStoreAction> = useContext(AppDispatchContext);


    // const tourConfig: ReactourStep[] = [
    //     {
    //         selector: '[data-tut="reactour__dashboard_analytics"]',
    //         content: `Analytics shows brief about your sales on shopify.`,
    //     },
    //     {
    //         stepInteraction: false,
    //         selector: '[data-tut="reactour__dashboard_reviews"]',
    //         content: `Here you will see recent reviews of your shop's products.`,
    //     },
    //     {
    //         selector: '[data-tut="reactour__dashboard_chat"]',
    //         content: `Here you will see recent Chat sessions of your shop.`,
    //     },
    //     {
    //         selector: '[data-tut="reactour__dashboard_email_campaigns"]',

    //         content: ({goTo}: any) => (
    //             <div>
    //                 If you wanna go anywhere, skipping places, it is absolutely possible.
    //                 <br/> "Oh, I forgot something inside the bus…"{" "}
    //                 <button
    //                     style={{
    //                         border: "1px solid #f7f7f7",
    //                         background: "none",
    //                         padding: ".3em .7em",
    //                         fontSize: "inherit",
    //                         display: "block",
    //                         cursor: "pointer",
    //                         margin: "1em auto"
    //                     }}

    //                 >
    //                     Please go back to{" "}
    //                     <span aria-label="bus" role="img">
    //         🚌
    //       </span>
    //                 </button>
    //             </div>
    //         )
    //     },
    //     {
    //         selector: '[data-tut="reactour___campaigns"]',
    //         content: () => (
    //             <Text1>
    //                 The <Tooltip data-tooltip="this helper ⬇">tourist guide</Tooltip> could
    //                 be positioned where you want.
    //                 <br/> In this case will try to stay in the <strong>
    //                 left side
    //             </strong>{" "}
    //                 if there's available space, otherwise will{" "}
    //                 <strong>auto position</strong>.
    //             </Text1>
    //         ),
    //         position: "left"
    //     },
    //     {
    //         selector: '[data-tut="reactour__dashboard_suggestions"]',
    //         content:
    //             "Probably you noted that the Tour scrolled directly to the desired place, and you could control the time also…"
    //     },
    //     {
    //         selector: '[data-tut="reactour__header_shopify"]',
    //         content:
    //             "Manage Your Shopify store from here"
    //     },
    //     {
    //         selector: '[data-tut="reactour__header_dashboard"]',
    //         content: () => (
    //             <div>
    //                 If you wanna go anywhere, skipping places, it is absolutely possible.
    //                 <br/> "Oh, I forgot something inside the bus…"{" "}
    //                 <button
    //                     style={{
    //                         border: "1px solid #f7f7f7",
    //                         background: "none",
    //                         padding: ".3em .7em",
    //                         fontSize: "inherit",
    //                         display: "block",
    //                         cursor: "pointer",
    //                         margin: "1em auto"
    //                     }}
    //                     onClick={() => {
    //                         //history.push("/email")
    //                     }}
    //                 >
    //                     Please go back to{" "}
    //                     <span aria-label="bus" role="img">
    //         🚌
    //       </span>
    //                 </button>
    //             </div>
    //         )
    //     },
    //     {
    //         selector: '[data-tut="reactour__scroll--hidden"]',
    //         content: "Also when places are pretty hidden…"
    //     },
    // ];


    return null;
    // return <Tour
    //
    //     key={tour && tour.tour_type}
    //     onRequestClose={closeTour}
    //     steps={
    //         getTourSteps()
    //     }
    //
    //     isOpen={!!(tour && tour.tour_active)}
    //     maskClassName="tour-mask"
    //     className="helper"
    //     updateDelay={5000}
    //     disableFocusLock
    //     showNavigation={true}
    //     prevStep={()=>{
    //
    //     }}
    //     showNumber={false}
    //     showNavigationNumber={false}
    //     prevButton={false}
    //     accentColor={"#6500ff"}
    //     onAfterOpen={disableBodyScroll}
    //     onBeforeClose={enableBodyScroll}
    // />
}
